import axiosInstance from './AxiosInstance';

export const listForums = (params = {}) =>
  axiosInstance.get('/forum/forums', { params });

export const getForum = (id) =>
  axiosInstance.get(`/forum/forums/${id}`);

export const createForum = (formData) =>
  axiosInstance.post('/forum/forums', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateForum = (id, formData) =>
  axiosInstance.put(`/forum/forums/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteForum = (id) =>
  axiosInstance.delete(`/forum/forums/${id}`);

export const changeForumStatus = (id, status) =>
  axiosInstance.patch(`/forum/forums/${id}/status`, { status });

export const toggleForumFavorite = (id) =>
  axiosInstance.post(`/forum/forums/${id}/favorite`);

export const getForumHistory = (id) =>
  axiosInstance.get(`/forum/forums/${id}/history`);

export const getForumComments = (id) =>
  axiosInstance.get(`/forum/forums/${id}/comments`);

export const addForumComment = (forumId, formData) =>
  axiosInstance.post(`/forum/forums/${forumId}/comments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const closeForumComment = (commentId) =>
  axiosInstance.patch(`/forum/comments/${commentId}/close`);

export const deleteForumComment = (commentId) =>
  axiosInstance.delete(`/forum/comments/${commentId}`);

export const getCommentTaskPrefill = (commentId) =>
  axiosInstance.get(`/forum/comments/${commentId}/task-prefill`);

/** Merge discussion org + individual participants into task prefill (works when API only returns title/body). */
export const enrichForumTaskPrefill = (prefill, forum) => {
  if (!prefill || !forum) return prefill;

  const participants = (forum.ForumMembers || [])
    .filter((member) => member.role === 'participant')
    .map((member) => member.CorporateUser)
    .filter((user) => user?.id)
    .map((user) => ({
      id: user.id,
      CorporateUserId: user.id,
      full_name: user.full_name,
      FullName: user.full_name,
      email: user.email || user.User?.email,
      Email: user.email || user.User?.email,
    }));

  const branchIds = (forum.ForumBranches || [])
    .map((item) => item.branch_id || item.Branch?.id)
    .filter(Boolean);
  const departmentIds = (forum.ForumDepartments || [])
    .map((item) => item.department_id || item.Department?.id)
    .filter(Boolean);
  const subDepartmentIds = (forum.ForumSubDepartments || [])
    .map((item) => item.sub_department_id || item.SubDepartment?.id)
    .filter(Boolean);

  const assignees = prefill.assignees?.length ? prefill.assignees : participants;

  return {
    ...prefill,
    BranchId: prefill.BranchId?.length ? prefill.BranchId : branchIds,
    DepartmentId: prefill.DepartmentId?.length ? prefill.DepartmentId : departmentIds,
    SubDepartmentId: prefill.SubDepartmentId?.length ? prefill.SubDepartmentId : subDepartmentIds,
    assignees,
    assigneeIds: assignees.map((user) => user.id),
  };
};

export const linkCommentTask = (commentId, taskId) =>
  axiosInstance.post(`/forum/comments/${commentId}/link-task`, { task_id: taskId });

export const exportForumPdf = (id) =>
  axiosInstance.get(`/forum/forums/${id}/export/pdf`, { responseType: 'blob' });

export const downloadForumAttachment = (fileId) =>
  axiosInstance.get(`/forum/attachments/${fileId}`, { responseType: 'blob' });
